import { useForm } from "react-hook-form";
import { useCallback } from "react";

export const useUserForm = () => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      firstname: "",
      lastname: "",
      email: "",
      msisdn: "",
      mfaenabled: true,
    },
    mode: "onTouched",
  });

  const resetForm = useCallback(() => {
    reset({
      firstname: "",
      lastname: "",
      email: "",
      msisdn: "",
      mfaenabled: true,
    });
  }, [reset]);

  const prefillForm = useCallback(
    (user) => {
      reset({
        firstname: user.firstname || "",
        lastname: user.lastname || "",
        email: user.email || "",
        msisdn: user.msisdn || "",
        mfaenabled: user.mfaenabled ?? true,
      });
    },
    [reset],
  );

  return {
    control,
    handleSubmit,
    resetForm,
    prefillForm,
  };
};

export default useUserForm;
